module.exports = "<h4 id=\"mdl\">MDL</h4>\n<p><strong>Customer:</strong> Cryptocurrency / Smart contracts project</p>\n<p><strong>Description:</strong> Ecosystem designed to facilitate the talent sourcing market. Insightful expertise in both IT technologies and the entertainment industry that allows to bring the most efficient and effective medium for collaboration between artists, bookers, and brands.</p>\n<p><strong>Languages:</strong>​ Ruby</p>\n<p><strong>Position:</strong> ​Software Developer</p>\n<p><strong>Role:​</strong></p>\n<ul>\n<li>MvP</li>\n<li>Authentication</li>\n<li>Api</li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/mdl.md
// module id = 6rxZ
// module chunks = 1